import { composables } from "@orange-marmalade/paginate-this";
import _ from "lodash";
import { toastr } from "react-redux-toastr";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";
import { COMPANY, ID } from "APP_ROOT/constants";

const pgActions = composables({ listId: "company/aircrafts" });

export function createAircraft(aircraft) {
  return (dispatch, getState) => {
    const companyId = getState().companyDetail.getIn([COMPANY, ID]);
    return api.companies.aircrafts.create(companyId, aircraft).then(() => {
      dispatch(pgActions.expire());
      return SUCCESS;
    });
  };
}

export function destroyAircraft(id) {
  return (dispatch, getState) => {
    const companyId = getState().companyDetail.getIn([COMPANY, ID]);
    api.companies.aircrafts
      .delete(companyId, id)
      .then(() => dispatch(pgActions.expire()))
      .catch(error => {
        toastr.error(
          "Error",
          _.get(error, "errors.base[0]"),
          "Unexpected error"
        );
      });
  };
}



// WEBPACK FOOTER //
// ./app/modules/companies/actions/aircrafts/actions.js